<template>
  <nav aria-label="breadcrumb" class="personal-data nav-breadcrumb nav-breadcrumb--modification">
    <ol class="breadcrumb">
      <li v-for="(item, idx) in path" :key="idx" class="breadcrumb-item" :class="{ active: idx === path.length -1 }">
        <router-link :class="{'main-breadcrumb-item': idx === 0}" :to="item.route.path" >{{$t(item.title)}}</router-link>
      </li>
    </ol>
  </nav>
</template>

<script>
  import _ from 'lodash'

  export default {
    data: () => ({
      path: []
    }),

    watch: {
      '$route': {
        handler: function(to, from) {
          const route = this.$route;

          const path = [
            { href: '#', title: 'main-page', route: { path: '/'} }
          ];

          const breadcrumbs = route.matched.filter(e => _.get(e, 'meta.breadcrumbs'));
          for (let record of breadcrumbs) {
            let title = _.get(record, 'meta.breadcrumbs.title') || _.get(record, 'meta.title');
            let computed = _.get(record, 'meta.breadcrumbs.computed') || _.get(record, 'meta.computed');

            if (!title && computed && record.instances.default) {
              const i = path.length;

              title = record.instances.default.breadcrumbs;

              if (!title) {
                record.instances.default.$watch('breadcrumbs', (value) => {
                  const p = {...this.path[i], title: value};
                  this.$set(path, i, p);
                });
              }
            }

            path.push({
              href: '#',
              route: record,
              title: title
            });
          }

          //setTimeout(() => {this.path[0].title = Date.now()}, 3000);
          this.path = path;
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main-breadcrumb-item {
    font-weight: 500!important;
    font-size: 1.2em!important;
    color: black!important;
  }
</style>
